import React, { useRef, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { ChevronDownIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { signOut } from "firebase/auth";
import { auth, db } from "../../config/firebaseConfig";
import { Button } from "../../components/catalyst/button";
import { useNavigate } from "react-router-dom";
import { clearUser } from "../../store/slices/authSlice";
import { createCheckoutSession } from "../../util/stripeClient";
import ReportCard from "../../components/ReportCardsComponent";
import HorizontalScrollerComponent from "../../components/HorizontalScrollerComponent";
import LogoutDialog from "../../components/dialogs/LogOutDialog";
import Snackbar from "../../components/ExistingSessionSnackbarComponent";
import { getFunctions, httpsCallable } from "firebase/functions";
import { Shimmer } from "../../components/ShimmerComponent";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";


type ReportElement = {
  id: string;
  title: string;
  shortDesc: string;
  price: number;
  isRelationShipReport: boolean;
  status?: string;
  url: string,
  isAvailable: boolean,
  predecessorTitles: string[]
};

type UserReport = {
  id: string;
  templateId: string | null;
  templateTitle: string;
  shortDesc: string;
  status: string;
  createdAt: any;
  price?: number | null;
  success?: boolean;
  url: string,
  isRelationShipReport:boolean,
  relatedPersonName?: string | null,
  relatedPersonRelation?: string | null
};

export default function QIDProfileDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();
  const user = useSelector((state: RootState) => state.auth.user);
  const isAdmin =  user?.role === "admin"
  const effectiveUserId =
  user?.role === "admin" && userId
    ? userId
    : user?.uid;
 
  const recRef = useRef<HTMLDivElement>(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackBarType, setSnackBarType] = useState<"success" | "error" | null>();

  const [effectiveUserData, setEffectiveUserData] = useState(user);
  const [loadingUser, setLoadingUser] = useState(false);
  const [publishedReports, setPublishedReports] = useState<ReportElement[]>([]);
  const [recommendedReports, setRecommendedReports] = useState<ReportElement[]>([]);
  const [userReports, setUserReports] = useState<UserReport[]>([]);
  const [loadingCard, setLoadingCard] = useState<string | null>(null);
  const [isLocked, setIsLocked] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [helperText, setHelperText] = useState<{
    text?: string | null;
    image?: string | null;
  } | null>(null);
  
  const [loadingHelperText, setLoadingHelperText] = useState(true);

  const functions = getFunctions();
  const callTemplateManager = httpsCallable(functions, "templateManager");
  const shouldShowHelperText =
  !loadingHelperText &&
  !!helperText?.image &&
  !!helperText?.text;

  const displayUser = isAdmin && effectiveUserData
  ? effectiveUserData
  : user;
  useEffect(() => {
    async function fetchUser() {
      try {
        console.log("user calleddddddddddddd----> ",)
        if (!effectiveUserId) {
          throw new Error("Missing userId");
        }
        // Normal user → no fetch
        if (!isAdmin || !userId) {
          setEffectiveUserData(user);
          console.log("user",user?.helperText)
          setHelperText(user?.helperText || null);
          return;
        }
  
        setLoadingUser(true);
  
        // 🔥 Firestore fetch
        const userRef = doc(db, "users", userId);
        const userSnap = await getDoc(userRef);
  
        if (!userSnap.exists()) {
          throw new Error("User not found");
        }
  
        console.log("user Datataaaaaaaaaaaaaaaaaaaa----> ", )
        setEffectiveUserData({
          uid: effectiveUserId,
          email: userSnap.data().email ,
          displayName: userSnap.data().profile?.identity.fullName,
          emailVerified: userSnap.data().emailVerified,
          basicInfoSetup: userSnap.data().basicInfoSetup,
          dob: userSnap.data().profile?.birth.date,
          hasReports: userSnap.data().hasReports,   
          role: 'user' ,
          disabled: userSnap.data().disabled
        });
        setHelperText(userSnap.data().helperText || null);
        
  
      } catch (err) {
        console.error("Error fetching user:", err);
        setLoadingHelperText(false);
      } finally {
        setLoadingHelperText(false);
        setLoadingUser(false);
        loadPublishedTemplates();
      }
      
      
    }
  
    fetchUser();
  }, [isAdmin, userId, user]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");

    if (payment === "success") {
      setSnackbarMessage("Thank you for your purchase. Your report is being processed.");
      setSnackBarType("success")
      setShowSnackbar(true);

      // reload data again because user just bought a report
      loadPublishedTemplates();
    }

    if (payment === "cancel") {
      setSnackbarMessage("⚠️ Your payment failed. Please retry.");
      setSnackBarType("error")
      setShowSnackbar(true);
    }

    // remove the query params
    if (payment) {
      window.history.replaceState({}, "", window.location.pathname);
    }

  }, []);

  async function loadPublishedTemplates() {
    try {
      let res;
      if(isAdmin){
        res = await callTemplateManager({ action: "fetchPublished", userIdRequested: effectiveUserId });
      }else{
        res = await callTemplateManager({ action: "fetchPublished" });
      }
      const data = res.data as {
        templates: ReportElement[];
        userReports: UserReport[];
        recommended: ReportElement[]
      };

      console.log("✅ Templates:", data.templates);
      console.log("✅ User Reports:", data.userReports);

      setPublishedReports(data.templates || []);
      setUserReports(data.userReports || []);
      setRecommendedReports(data.recommended || [])
      setLoadingProfile(false);
    } catch (err: any) {
      console.error("❌ Failed to fetch published templates:", err.message);
    }
  }

  function formatDOB(dob?: string | null): string {
    if (!dob) return "";
  
    // Parse manually to avoid timezone shift
    const [year, month, day] = dob.split("-").map(Number);
  
    if (!year || !month || !day) return dob;
  
    const date = new Date(year, month - 1, day); // local date, no UTC shift
  
    return date.toLocaleDateString("en", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  

  const handleBuy = async (itemTitle: string, reportId: string, amount: number, personID?: any ) => {
    console.log("hereppppp", amount)
    setIsLocked(true);
    setLoadingCard(itemTitle);

    console.log(personID)
    try {

      const email = user?.email || "";
      if (!email) {
        alert("User email not found");
        return;
      }

      console.log("here")
      const data = await createCheckoutSession(
        itemTitle,
        amount,
        email,
        reportId,
        user?.uid || "",
        user?.displayName || "",
        personID,
      );
      

      if (data.free) {
        setSnackbarMessage("Your report is being processed.");
        setSnackBarType("success");
        setShowSnackbar(true);
      
        // Reload list because workflow is already triggered
        await loadPublishedTemplates();
      
        return;
      }
      
      // ⭐ PAID — redirect to Stripe
      if (data.url) {
      window.location.href = data.url;
      }
    } catch (err: any) {
      console.error("Checkout error", err);
      if (err.code === "functions/failed-precondition") {
        setShowSnackbar(true);
      } else {
        alert("⚠️ Something went wrong. Please try again later.");
      }
    } finally {
      setIsLocked(false);
      setLoadingCard(null);
    }
  };

  const handleRePurchase = async(reportId: string, personID?: any):Promise<any> =>{
    console.log("asdasdasd")
    const createCheckoutSessionFn = httpsCallable(functions, "startReportWorkflowRerun");
    try {
     
      const result = await createCheckoutSessionFn({ reportId:reportId, type:"re-run"  });
  
      const sessionData = result.data as any;
      console.log(sessionData)
  
      // ⭐ Support free reports
      if (sessionData.success && sessionData.free) {
        setSnackbarMessage("Your report is being processed.");
        setSnackBarType("success");
        setShowSnackbar(true);
      
        // Reload list because workflow is already triggered
        await loadPublishedTemplates();
      
        return;
      }
      
      // ⭐ Normal Stripe redirect
      if (sessionData.url) {
        window.location.href = sessionData.url;
      }
      
      throw new Error("Invalid response from createCheckoutSession");
      
    } catch (err: any) {
      console.error("Error creating checkout session:", err);
      if (err.code && err.message) {
        // Rethrow structured Firebase HttpsError
        throw {
          code: err.code,
          message: err.message,
          details: err.details || null,
        };
      }
  
      // fallback: plain JS error
      throw new Error(err.message || "Unknown checkout session error");
    }

    
  }

  const handleLogout = async () => {
    try {
      dispatch(clearUser());
      await signOut(auth);
      navigate("/auth/login");
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  function capitalizeName(name: string): string {
    if (!name) return "";
    return name
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return (
    <div className="min-h-screen bg-dark-background">
      <header className="sticky top-0 z-40 border-b border-dark-border backdrop-blur">
        <div className="mx-auto px-6 h-16 flex items-center justify-between">
          <img src="/assets/QID-logo.svg" alt="QID logo" />
          <div className="sm:hidden relative">
            <button
              onClick={() => setShowMobileMenu(v => !v)}
              className="flex items-center gap-2"
            >
              {/* Round user initial */}
              {!isAdmin  && <div className="w-9 h-9 rounded-full bg-brand-600 text-white flex items-center justify-center font-bold">
                {String(user?.displayName ?? "U").trim().charAt(0).toUpperCase()}
              </div>}
              {isAdmin && <div className="w-9 h-9 rounded-full bg-brand-600 text-white flex items-center justify-center font-bold">
                {String(effectiveUserData?.displayName ?? "U").trim().charAt(0).toUpperCase()}
              </div>}

              {/* Dropdown Icon */}
              <ChevronDownIcon
                className={`w-5 h-5 text-white transition-transform ${showMobileMenu ? "rotate-180" : ""
                  }`}
              />
            </button>

            {/* Drop-down Menu */}
            {showMobileMenu && (
              <div className="absolute right-0 mt-3 w-40 bg-dark-background-secondary border border-dark-border rounded-xl shadow-lg py-2 z-50">

                <button
                  onClick={() => navigate("/user/profile")}
                  className="w-full text-left px-4 py-2 text-sm text-white hover:bg-dark-background-secondary-medium"
                >
                  View account
                </button>

                {!isAdmin && <button
                  onClick={() => setLogoutDialogOpen(true)}
                  className="w-full text-left px-4 py-2 text-sm text-dark-text-warn hover:bg-dark-background-secondary-medium"
                >
                  Logout
                </button>}

              </div>
            )}
          </div>

        </div>

      </header>

      <main className="mx-auto max-w-6xl px-4 py-8">
        <div className="overflow-hidden rounded-2xl pb-6 bg-dark-background-secondary">
          <div className="p-6 flex flex-col gap-6">
            <div className="flex gap-4 w-full justify-between items-start">
              {loadingProfile ? (
                <div className="space-y-3">
                  <Shimmer className="h-7 w-40" />
                  <Shimmer className="h-5 w-56" />
                  <Shimmer className="h-5 w-32" />
                </div>
              ) : (
                <div>
                  <h1 className="text-2xl font-semibold text-white">
                    {capitalizeName(displayUser?.displayName || "Anonymous User")}
                  </h1>
                  <div className="mt-1 text-xl text-dark-text-color">
                    <div>{displayUser?.email}</div>
                    {/* {user?.dob && <span>DOB: {user.dob}</span>} */}
                    {displayUser?.dob && (
                      <div className="">
                        DOB: {formatDOB(displayUser.dob)}
                      </div>
                    )}
                  </div>
                </div>
              )}


              <div className="hidden sm:flex items-center gap-3">
                {!isAdmin && <Button
                  plain
                  onClick={() => setLogoutDialogOpen(true)}
                  className="!text-dark-text-warn bg-dark-background-secondary-medium flex items-center"
                >
                  <ArrowRightOnRectangleIcon className="h-4 w-4" />
                  Logout
                </Button>}

                {!isAdmin && <Button
                  type="button"
                  color="brand"
                  onClick={() => navigate("/user/profile")}
                >
                  View account
                </Button>}
              </div>

            </div>
          </div>

          {loadingProfile &&
            <div className="mt-6 p-6">

              {/* 3 shimmers */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Shimmer className="h-[400px] w-full sm:w-[280px] rounded-2xl" />
                <Shimmer className="h-[400px] w-full sm:w-[280px] rounded-2xl" />
                <Shimmer className="h-[400px] w-full sm:w-[280px] rounded-2xl" />
              </div>

              {/* Bottom shimmer (always full width) */}
              <Shimmer className="mt-6 h-6 w-full rounded-2xl" />

            </div>
          }

{shouldShowHelperText && (
  <div className="mx-[30px] flex gap-[20px] text-white rounded-2xl border border-[#615FFF] bg-[#1E1A4D] p-[20px]">
    <img
      className="h-[110px] w-[110px] rounded-xl object-cover shrink-0"
      src={helperText!.image!}
      alt="Helper"
    />

    <div className="flex-1 prose prose-invert max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeSanitize]}
      >
        {helperText!.text!}
      </ReactMarkdown>
    </div>
  </div>
)}


          {/* 🟢 User Reports */}
          {userReports.length > 0 && (
            <div className="mt-6 px-6">
              <HorizontalScrollerComponent title="Your Reports">
                {userReports.map((r) => (
                  <div key={r.id} className="min-w-[280px] flex-shrink-0 snap-start">
                    <ReportCard
                      title={r.templateTitle}
                      description={r.shortDesc}
                      status={r.status}
                      onBuy={(personID ) => handleRePurchase(r.id)}
                      price={r.price || 0}
                      imageUrl={r.url}
                      userId={user?.uid || ''}
                      reportId={r.id}
                      isRelationship={r.isRelationShipReport}
                      relatedData = { {
                        relatedName:r.relatedPersonName || null,
                        relatedRelation: r.relatedPersonRelation || null}
                      }
                    />
                    {/* onClick={() => navigate(`/admin/report/update/${r.id}`)} */}
                  </div>
                ))}
              </HorizontalScrollerComponent>
            </div>
          )}

          {/* 🟣 Recommended Templates */}
          {recommendedReports.length > 0 && (
            <div className="mt-6 px-6">
              <HorizontalScrollerComponent title="Recommended for you">
                {recommendedReports.map((r) => (
                  <div key={r.id} className="min-w-[280px] flex-shrink-0 snap-start">
                    <ReportCard
                      title={r.title}
                      price={r.price}
                      description={r.shortDesc}
                      status={r.status}
                      onBuy={( personID ) => handleBuy(r.title, r.id, Math.round(r.price * 100), personID)}
                      isLoading={loadingCard === r.title}
                      disabled={isLocked && loadingCard !== r.title}
                      imageUrl={r.url}
                      isRelationship={r.isRelationShipReport}
                      isAvailable={r.isAvailable}
                      userId={user?.uid || ''}
                      predecessorTitles={r.predecessorTitles}
                    />
                  </div>
                ))}
              </HorizontalScrollerComponent>
            </div>
          )}

          {/* Footer note */}
          {(recommendedReports.length > 0 ) && <div className="mt-6 px-6 flex gap-4 text-sm text-white">
            <InformationCircleIcon className="h-6 w-6 text-gray-500" />
            Each QID report reveals a distinct layer of your energetic identity.
            Whether you’re curious about your core resonance or navigating a
            spiritual transition, these reports offer insight into your name,
            your frequency, and your unfolding.
          </div>}

          {/* 🟣 Available Templates */}
          {publishedReports.length > 0 && (
            <div className="mt-6 px-6">
              <HorizontalScrollerComponent title="Browse Reports">
                {publishedReports.map((r) => (
                  <div key={r.id} className="min-w-[280px] flex-shrink-0 snap-start">
                    <ReportCard
                      title={r.title}
                      price={r.price}
                      description={r.shortDesc}
                      status={r.status}
                      onBuy={( personID ) => handleBuy(r.title, r.id, Math.round(r.price * 100),  personID)}
                      isLoading={loadingCard === r.title}
                      disabled={isLocked && loadingCard !== r.title}
                      imageUrl={r.url}
                      isRelationship={r.isRelationShipReport}
                      isAvailable={r.isAvailable}
                      userId={user?.uid || ''}
                      predecessorTitles={r.predecessorTitles}
                    />
                  </div>
                ))}
              </HorizontalScrollerComponent>
            </div>
          )}




          
        </div>
      </main>

      {/* 🔐 Logout Dialog */}
      <LogoutDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={() => {
          setLogoutDialogOpen(false);
          handleLogout();
        }}
      />

      {/* ⚠️ Snackbar */}
      {showSnackbar && (
        <Snackbar
          message={snackbarMessage}
          type={snackBarType}
        />
      )}
    </div>
  );
}
